import React, {  } from 'react';
import { Link } from 'react-router-dom';


const ErrorPage = (props) => {
    return(
        <div className='flex flex-col justify-center items-center h-screen w-screen'>
            <div className='text-3xl sm:text-2xl font-bold'>404 - Page Not Found</div>
            <span className='mt-4 font-semibold'><Link to={`/`}>{`>./`}home</Link></span>
        </div>
    );
}


export default ErrorPage;